import { Icon, Label, SimpleTooltip, SwitchInput } from 'corso-admin-ui';

type ExternalResolutionModifierProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export default function ExternalResolutionModifier({
  checked,
  onChange,
}: ExternalResolutionModifierProps) {
  const descriptionId = 'resolved-externally-description';

  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2">
          {' '}
          <Label htmlFor="resolved-externally">Resolved Outside Corso </Label>
          <SimpleTooltip
            content={
              <div className="max-w-sm space-y-3 text-sm text-neutral-800">
                <p>
                  Resolved outside Corso should be used when the customer&apos;s
                  issue was handled outside Corso&apos;s platform, for example
                  if you issued a manual refund or did an in-store exchange.
                </p>
                <p>
                  Corso will not create refunds or replacement orders when you
                  finalize the claim, but will update the claim to show it was
                  resolved elsewhere while keeping your reporting data intact.
                </p>
              </div>
            }
          >
            <Icon icon="info" />
          </SimpleTooltip>
        </div>

        <SwitchInput
          label="Resolved Outside Corso"
          labelVisuallyHidden
          id="resolved-externally"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          aria-describedby={descriptionId}
        />
      </div>

      <p id={descriptionId} className="text-xs leading-snug">
        This item was resolved outside of the Corso platform.
      </p>
    </div>
  );
}
